import { plan } from '../../llm-planning';
import type { PlanFn } from './types';

export const genericXmlPlan: PlanFn = plan;
